export default {
      id: "search-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#search",
      toString: function () {
        return this.url;
      }
    }